export default () => {

    // Interval of the timer
    const intervalTime = 1500;
    // Smart Queue
    let projectsQueue = {};

    // const interval = setInterval(performCall, intervalTime);
    setInterval(performCall, intervalTime);

    self.addEventListener('message', e => {

        const { projectId, driverId, driverProperties } = e.data;

        if (!(projectId in projectsQueue)) {
            projectsQueue[projectId] = {};
        }

        if (!(driverId in projectsQueue[projectId])) {
            projectsQueue[projectId][driverId] = {};
        }

        driverProperties.forEach(driverProperty => {
            projectsQueue[projectId][driverId][driverProperty.id] = driverProperty;
        });

        postMessage({
            type: "queue",
            data: projectsQueue,
        });
    })

    // function cleanUp() {
    //   clearInterval(interval);
    // }

    function performCall() {

        if (Object.keys(projectsQueue).length === 0) {
            return;
        }

        Object.keys(projectsQueue).forEach(projectId => {
            const project = projectsQueue[projectId];
            Object.keys(project).forEach(driverId => {
                const driver = project[driverId];
                const driverProperties = Object.values(driver);

                this.postMessage({ projectId, driverId, driverProperties });
            });
        });

        projectsQueue = {};
        this.postMessage({
            type: "queue",
            data: projectsQueue,
        });
    }
}
